import React from 'react';
import './Modal.css'

interface PasswordModalProps {
  message: string;
  onSuccess: Function;
  onCancel: Function;
}

interface PasswordModalState {
  password: string;
  error: string;
}

class PasswordModal extends React.Component<PasswordModalProps, PasswordModalState> {
  constructor(props:PasswordModalProps) {
    super(props);
    this.state = {
      password: '',
      error: ''
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }
  
  onSubmit() {
    const correctPassword = 'converge';
    const enteredPassword = this.state.password.trim();
    
    if (enteredPassword.toLowerCase() === correctPassword.toLowerCase()) {
      // Save to localStorage
      localStorage.setItem('oneClickBetaPassword', enteredPassword);
      this.props.onSuccess();
    } else {
      this.setState({ error: 'Incorrect password. Please try again.' });
    }
  }

  onCancel() {
    this.props.onCancel();
  }

  onPasswordChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ 
      password: e.target.value,
      error: '' // Clear error when user types
    });
  }

  onKeyPress(e: React.KeyboardEvent) {
    if (e.key === 'Enter') {
      this.onSubmit();
    }
  }

  render() {
    if(this.props.message == '')
      return (null);

    return (
      <div className="modal open">
        <div className="modal-content" style={{width: '300px', textAlign: 'center'}}>
          <div style={{marginBottom: '20px'}}>{this.props.message}</div>
          <div style={{marginBottom: '15px'}}>
            <input
              type="password"
              value={this.state.password}
              onChange={this.onPasswordChange}
              onKeyPress={this.onKeyPress}
              placeholder="Enter password"
              style={{
                width: 'calc(100% - 16px)',
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '14px',
                boxSizing: 'border-box'
              }}
              autoFocus
            />
          </div>
          {this.state.error && (
            <div style={{color: 'red', fontSize: '12px', marginBottom: '15px'}}>
              {this.state.error}
            </div>
          )}
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '10px'}}>
            <button onClick={this.onCancel}>Cancel</button>
            <button onClick={this.onSubmit}>Submit</button>
          </div>
        </div>
      </div>
    )
  }
}

export default PasswordModal; 